// @ts-strict-ignore
import React, { useCallback, useEffect, useState } from 'react'
import classNames from 'classnames'

interface InputProps {
  type: string
  value: number
  onChange?: Function
  name: string
  prefix?: string
  suffix?: string
  format?: string
  error?: boolean
  buttonActions?: Record<string, string | number>
}

export const formatThousands = (n) => {
  const s = n.toString()
  const [int, dec] = s.split('.')
  const intFormatted = int.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  return dec ? `${intFormatted}.${dec}` : intFormatted
}

const Input = ({
  type,
  value,
  onChange,
  name,
  prefix,
  suffix,
  format,
  error = false,
  buttonActions,
}: InputProps) => {
  const formatString = (str: string) => {
    if (type === 'text' && format !== 'thousands') {
      return str
    }
    const s = str.replace(/[^0-9]/g, '')
    return format === 'thousands' ? formatThousands(s) : s
  }
  const toInteger = (v) => {
    if (format === 'thousands') {
      const parsed = parseInt(v.replace(/[^0-9]/g, ''))
      return isNaN(parsed) ? 0 : parsed
    }

    return type === 'number' ? parseInt(v) : v
  }

  const toString = useCallback(
    (v: number) => {
      const s = v.toString()
      return format === 'thousands' ? formatThousands(s) : s
    },
    [format],
  )

  const [valueString, setValueString] = useState(toString(value))

  useEffect(() => {
    setValueString(toString(value))
  }, [value, toString])

  const handleChange = (e) => {
    setValueString(formatString(e.target.value))

    {
      onChange &&
        onChange({
          ...e,
          target: {
            ...e.target,
            value: toInteger(e.target.value),
          },
        })
    }
  }

  return (
    <div className='Platinum-input-wrapper'>
      {prefix && (
        <span className='Platinum-input-prefix' data-input-prefix-selector-content>
          {prefix}
        </span>
      )}
      <input
        name={name}
        data-format={format}
        data-calculator-value={valueString}
        type={type}
        onChange={handleChange}
        value={valueString}
        className={classNames('Platinum-input', {
          'Platinum-input-prefix-space': prefix,
          'Platinum-input-suffix-space': suffix,
          'Platinum-input__error': error,
        })}
        {...buttonActions}
      />
      {suffix && <span className='Platinum-input-suffix'>{suffix}</span>}
    </div>
  )
}

export default Input
